<template>
    <!-- 附件 弹框 -->
    <el-dialog
        :closeOnClickModal='true'
        class="attachment receiptSignattachment"
        title="附件预览"
        :visible="true"
        :close-on-press-escape="flag"
        :before-close="beforeClose"
        :append-to-body='true'
        width="60%">
        <div class="attachmentLeft">
            <div style="height: 380px;">
                <ul id='viewers' style="display: none;">
                    <li v-for="(item, index) in imgArr" :key="index">
                            <img :src="item.propertiesValue" />
                    </li>
                </ul>
            </div>
            <div class="img-page" v-show="imgArr.length">{{ carouselIndex + 1 + ' / ' + imgArr.length}}</div>
        </div>
    </el-dialog>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
    components: {},
    props: {
        attachmentShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialogLoading: {}, // 弹框loading实例
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            imgArr: [],
            uploadName: '',
            uploadTime: '',
            flag: true
        };
    },
    methods: {
        loading(status = true) {
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.receiptSignattachment > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        beforeClose() {
            this.$emit('update:attachmentShow', false);
        },
        updateViewer() {
            this.carouselIndex = 0;
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                toolbar: {
                    zoomIn: false,
                    zoomOut: false,
                    prev: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                this.carouselIndex = this.imgArr.length - 1;
                            } else {
                                this.carouselIndex -= 1;
                            }
                            this.viewer.prev(true);
                        }
                    },
                    reset: false,
                    next: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                this.carouselIndex = 0;
                            } else {
                                this.carouselIndex += 1;
                            }
                            this.viewer.next(true);
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        getImgList() {
            this.imgArr = this.rowData.propertiesList;
            this.$nextTick(() => {
                this.keyDown();
                this.initViewer();
            });
        },
        /**
         * @description: 判断键盘事件 实现逐级退出功能
         * @return {*}
         */
        keyDown () {
            document.onkeydown = e => {
                if (e.code === 'Escape') {
                    this.flag = !(e.target.className === 'viewer-button viewer-fullscreen viewer-fullscreen-exit');
                }
            };
        }
    },
    created() {
        this.getImgList();
    },
    beforeDestroy() {
        this.viewer.destroy();
    }
};
</script>

<style lang="less">
.receiptTile {
    .attachment {
        .attachmentLeft {
            position: relative;
            .loadingBox {
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: #fff;
                z-index: 1000;
                .progress {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
}
.receiptSignattachment {
    .attachment-title {
        text-align: center;
        font-size: 16px;
        .upload-user, .upload-time {
            font-weight: bold;
            margin: 0 10px;
        }
    }
    .img-page {
        text-align: center;
    }
}
</style>
